import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class RefundMetricsService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getMetrics(fromDate, toDate, contratoId) {
    try {
      const params = { fromDate, toDate };
      if (contratoId) params.contratoId = contratoId;
      const res = await axios.get(`${adminUrl}/refunds/metrics`, {
        headers: this.getHeaders(),
        params,
      });
      return { status: 'ok', data: res.data.data };
    } catch (err) {
      console.error('[RefundMetrics] getMetrics error:', err?.response?.data || err.message);
      return { status: 'error', data: null };
    }
  }

  static async getByContract({ search, fromDate, toDate } = {}) {
    try {
      const params = {};
      if (search) params.search = search;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      const res = await axios.get(`${adminUrl}/refunds/by-contract`, {
        headers: this.getHeaders(),
        params,
      });
      return { status: 'ok', data: res.data.data };
    } catch (err) {
      console.error('[RefundMetrics] getByContract error:', err?.response?.data || err.message);
      return { status: 'error', data: null };
    }
  }

  static async getInsights(fromDate, toDate) {
    try {
      const params = {};
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      const res = await axios.get(`${adminUrl}/refunds/insights`, {
        headers: this.getHeaders(),
        params,
      });
      return { status: 'ok', data: res.data.data };
    } catch (err) {
      console.error('[RefundMetrics] getInsights error:', err?.response?.data || err.message);
      return { status: 'error', data: null };
    }
  }

  static async getTrend({ granularity, fromDate, toDate, months } = {}) {
    try {
      const params = {};
      if (granularity) params.granularity = granularity;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      if (months) params.months = months;
      const res = await axios.get(`${adminUrl}/refunds/trend`, {
        headers: this.getHeaders(),
        params,
      });
      return { status: 'ok', data: res.data.data };
    } catch (err) {
      console.error('[RefundMetrics] getTrend error:', err?.response?.data || err.message);
      return { status: 'error', data: null };
    }
  }
}
